import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { MatLegacyDialog as MatDialog,MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA   } from '@angular/material/legacy-dialog';
import { DictionaryEntry } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { Article } from 'src/erp-articles/catalog/catalog.model';
import { Description } from 'src/erp-articles/erp-common/erp-common.model';

@Component({
  selector: 'app-description-editor',
  templateUrl: './description-editor.component.html',
  styleUrls: ['./description-editor.component.scss']
})
export class DescriptionEditorComponent implements OnInit {

  article: Article;

  description: Description;
  originalDescription: Description;

  formGroup = new FormGroup({});

  isNew = false;

  constructor(
    public translationService: TranslationService,
    public dialogRef: MatDialogRef<DescriptionEditorComponent>,
    private matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    if (data.article != null) {
      this.article = data.article;
    }

    if (data.description != null) {
      this.originalDescription = data.description;
      this.description = new Description(data.description);
      this.isNew = false;
    } else {
      this.description = new Description({});
      this.isNew = true;
    }

    console.log(this.description);

    this.formGroup.addControl('usage', new FormControl(false, []));
  }

  ngOnInit(): void {

    this.formGroup.patchValue({
      usage: this.description?.usage
    });

    this.formGroup.valueChanges.subscribe(formValues => {
      this.description.usage = formValues.usage;
    });
  }

  onClose() {
    this.dialogRef.close();
  }

  onConfirm() {

    if (this.isNew && this.article != null && this.description != null) {
      this.article.descriptions.push(this.description);
    } else if (this.originalDescription != null) {
      this.originalDescription.text = this.description.text;
      this.originalDescription.title = this.description.title;
      this.originalDescription.usage = this.description.usage;
    }

    this.dialogRef.close();
  }

  confirmDisabled(): boolean {
    return !this.formGroup.valid || this.description?.title == null || !this.description?.title.checkValueExistsForLanguage('de');
  }

  public onTitleChanged(dictionary: DictionaryEntry) {
    this.description.title = new DictionaryEntry(dictionary);
  }

  public onTextChanged(dictionary: DictionaryEntry) {
    this.description.text = new DictionaryEntry(dictionary);
  }

}
